import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import IdleTimer from "react-idle-timer";
import { menuTypeAction } from "./store/actions";
import { connect } from "react-redux";
import { IkioskMenuIds } from "./models/kioskModel";
import moment from "moment";
import { getSessionTime } from "./helpers/helpersIndex";

class AppIdle extends Component {
  constructor(props) {
    super(props);
    this.state = {
      timeout: 60000 * getSessionTime(),
    };
    this.idleTimer = null;
    this.onAction = this._onAction.bind(this);
    // this.onActive = this._onActive.bind(this);
    this.onIdle = this._onIdle.bind(this);
  }
  _onAction(e) {
    console.log("useridle did something",e,this.idleTimer,this.props.kioskMenutype);
    if (this.props.kioskMenutype === IkioskMenuIds.PROMOTIONALSLIDE){
      this.props.menuTypeAction(IkioskMenuIds.LOGINPAGE);
    }
    // this.setState({ isTimedOut: false })
  }

  _onActive(e) {
    console.log("useridle is active", e);
    // this.setState({ isTimedOut: false })
  }

  _onIdle(e) {
    console.log("useridle is idle", e, this.props.history.location.pathname);
    const currentMoment = moment(this?.props?.dateTime);
    const startMoment = moment(this?.props?.kioskStartTime, "HH:mm");
    const endMoment = moment(this?.props?.kioskEndTime, "HH:mm");
    const isStartTimeExceeded = currentMoment.isSameOrAfter(startMoment, 'minute');
    const isEndTimeExceeded = currentMoment.isSameOrAfter(endMoment, 'minute');
    const startTimeExceed = currentMoment.isBefore(startMoment, 'minute');
    if (!((isStartTimeExceeded && isEndTimeExceeded) || (startTimeExceed)) && (this?.props?.promotionalData?.length > 0) && (this.props.kioskMenutype === IkioskMenuIds.LOGINPAGE))
      {
        this.props.menuTypeAction(IkioskMenuIds.PROMOTIONALSLIDE);
      }
    this.idleTimer.reset();
  }
  render() {
    return (
      <>
        <IdleTimer
          ref={(ref) => {
            this.idleTimer = ref;
          }}
          element={document}
          //   onActive={this.onActive}
          onIdle={this.onIdle}
          onAction={this.onAction}
          debounce={500}
          timeout={(1000 * this.props.kioskIdleTime) || this.state.timeout}
        />
        {console.log("idleTime",{reducerIdle:this.props.kioskIdleTime,appsettingsIdle:this.state.timeout})}
      </>
    );
  }
}
const mapStateToProps = (state) => ({
  kioskMenutype: state?.kioskReducer?.selectedPage,
  dateTime: state?.kioskReducer?.currentDateAndTime,
  kioskStartTime: state?.kioskReducer?.kioskStartTime,
  kioskEndTime: state?.kioskReducer?.kioskEndTime,
  promotionalData: state?.kioskReducer?.promotionalData,
  kioskIdleTime: state?.kioskReducer?.idleTime,
});

export default withRouter(
  connect(mapStateToProps, { menuTypeAction })(AppIdle)
);
